document.addEventListener('Searchanise.Loaded', function() {
  (function($) {
    var search_data;

    Searchanise.SetOptions({
      PriceFormatDecimalSeparator: ',' ,
      PriceFormatThousandsSeparator: '',
      PriceFormatBefore: '',
      PriceFormatAfter: ' €'
    });

    $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
      search_data = data.items;
    });

    $(document).on('Searchanise.ResultsUpdated', function() {
      for (var i = 0; i < search_data.length; i++) {
        var element = search_data[i];
        var productEl = $('#snize-product-' + element.product_id);

        if (productEl.length) {
          productEl[0].dataset.collectionsTitles = element.collections.split('[:ATTR:]').join(';');
        }

        if (!productEl.find('[data-bv-card-summary-slot], [data-bv-card-summary]').length) {
          var sku = (element.shopify_variants && element.shopify_variants[0] && element.shopify_variants[0].sku) || '';
          var href = productEl.find('a.snize-view-link').attr('href') || '';

          productEl.find('.snize-overhidden').prepend(
            '<div data-bv-card-summary-slot data-product-sku="' + sku + '" data-product-href="' + href + '"></div>'
          );

          if (window.mmkt && window.mmkt.bazaarvoice && typeof window.mmkt.bazaarvoice.hydrateCardSummary === 'function') {
            window.mmkt.bazaarvoice.hydrateCardSummary(productEl[0]);
          }
        }
      }
    });
  })(window.Searchanise.$);
});